import getApiClient from '@/plugins/api'

export default {
  changePage: function (page) {
    this.page = page
  },

  loadPayables() {
    const self = this;
    const api = getApiClient(self.$root.$store);

    self.$store.commit('startLoading')

    self.searchParams.page = self.page
    self.searchParams.itemsPerPage = self.perPage
    self.searchParams['order.status'] = [3, 4, 6, 8];

    api.get('settings/comission_percent')
      .then(response => {
        self.commissionPercent = response.data.value

        api.get('agency_payables', {
          params: self.searchParams
        })
          .then((result) => {
            self.payables = result.data['hydra:member']
            self.totalPages = Math.ceil(result.data['hydra:totalItems'] / self.perPage)
          })
          .catch((error) => {
            console.log(error)
          })
          .finally(() => {
            self.$store.commit('stopLoading')
          })
      })
  },
}
